import { CircleDollarSign } from "lucide-react";
import { useTranslations } from "next-intl";
import { Badge } from "@/components/ui/design-system/badge";
import { Card } from "@/components/ui/design-system/card";
import { Body, CardTitle } from "@/components/ui/design-system/text";

/**
 * Money on the table, dressed the way the portal dresses its bounties: the
 * `nf-bounty-highlight` glow and the green `ok` badge with the same coin. The
 * creator meets this treatment again on Updates once they're in, so it reads
 * as "this pays" in both places rather than as two unrelated highlights.
 */
export function CreatorBonusCard() {
  const t = useTranslations("apply");
  return (
    <Card className="nf-bounty-highlight">
      <Badge variant="ok">
        <CircleDollarSign className="size-3.5" />
        {t("bonus.badge")}
      </Badge>
      <CardTitle as="h2" className="mt-nf-ds-3">
        {t("bonus.title")}
      </CardTitle>
      <Body muted className="mt-nf-ds-2">
        {t("bonus.body")}
      </Body>
    </Card>
  );
}
